var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 11.8565 3.7375 13.637 5.05025 14.9497C6.36301 16.2625 8.14348 17 10 17C11.8565 17 13.637 16.2625 14.9497 14.9497C16.2625 13.637 17 11.8565 17 10C17 8.14348 16.2625 6.36301 14.9497 5.05025C13.637 3.7375 11.8565 3 10 3C8.14348 3 6.36301 3.7375 5.05025 5.05025C3.7375 6.36301 3 8.14348 3 10V10Z",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.20001,
    y: 9.2998,
    width: 1.6,
    height: 4.5,
    rx: 0.8,
    fill: "#525D71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C9.90111 7 9.80444 7.02932 9.72221 7.08427C9.63999 7.13921 9.5759 7.2173 9.53806 7.30866C9.50022 7.40002 9.49032 7.50056 9.50961 7.59755C9.5289 7.69454 9.57652 7.78363 9.64645 7.85355C9.71637 7.92348 9.80547 7.9711 9.90246 7.99039C9.99945 8.00968 10.1 7.99978 10.1913 7.96194C10.2827 7.9241 10.3608 7.86001 10.4157 7.77779C10.4707 7.69556 10.5 7.59889 10.5 7.5C10.5 7.36739 10.4473 7.24021 10.3536 7.14645C10.2598 7.05268 10.1326 7 10 7Z",
    fill: "#525D71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C9.90111 7 9.80444 7.02932 9.72221 7.08427C9.63999 7.13921 9.5759 7.2173 9.53806 7.30866C9.50022 7.40002 9.49032 7.50056 9.50961 7.59755C9.5289 7.69454 9.57652 7.78363 9.64645 7.85355C9.71637 7.92348 9.80547 7.9711 9.90246 7.99039C9.99945 8.00968 10.1 7.99978 10.1913 7.96194C10.2827 7.9241 10.3608 7.86001 10.4157 7.77779C10.4707 7.69556 10.5 7.59889 10.5 7.5C10.5 7.36739 10.4473 7.24021 10.3536 7.14645C10.2598 7.05268 10.1326 7 10 7",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedInfo);
export default __webpack_public_path__ + "static/media/ic-shared-info.64aa8361dbeabcf4ca445aa8c9f3893a.svg";
export { ForwardRef as ReactComponent };